export default __webpack_public_path__ + "static/dimo-6ce493a42e67846b28ea6c28526a4068.svg";